// extracted by mini-css-extract-plugin
export var XL = "SplitContent-module--XL--3726f";
export var center = "SplitContent-module--center--a8b7c";
export var content = "SplitContent-module--content--14182";
export var copyBlockContainer = "SplitContent-module--copyBlockContainer--1bd0d";
export var gatsbyImage = "SplitContent-module--gatsbyImage--252df";
export var imageContainer = "SplitContent-module--imageContainer--c6e2d";
export var offWhite = "SplitContent-module--offWhite--7a1af";
export var onethird_twothirds = "SplitContent-module--onethird_twothirds--2fd63";
export var seaGreen = "SplitContent-module--seaGreen--d8b1d";
export var splitContent = "SplitContent-module--splitContent--0f67d";
export var top = "SplitContent-module--top--1fd52";
export var twothirds_onethird = "SplitContent-module--twothirds_onethird--06914";
export var videoContainer = "SplitContent-module--videoContainer--efecf";